<script>
import apiEndpoints from "@/services/apiEndpoints";
import tableSearch from "@/mixins/tableSearch";
import CommonTableComponent from "@/components/table.vue";
import {mapGetters} from "vuex";
import systemCode from "@/mixins/systemCode";
import moment from 'moment';
import Multiselect from "vue-multiselect";

export default {
  mixins: [tableSearch, systemCode],
  components: {
    CommonTableComponent,
    Multiselect
  },
  props: {
    dateStart: {
      type: Date,
      default: () => null
    }
  },
  data() {
    return {
      isLoading: false,
      dataSelected: [],
      filters: {
        qualification_id: null,
        column: "user.user_name",
        dir: "ASC",
        department_id: [],
        dateValue: "",
        assigned_cars: [],
      },
      staffBySearch: [],
      data: [],
      countHourHeader: 0,
      headers: [
        {
          text: "",
          value: "",
          sortable: false
        },
        {
          text: "作業者",
          value: "user.user_name",
          sortable: false,
          width: 35,
        },
        {
          text: "部門",
          value: "user.department.name",
          sortable: false,
          width: 45,
        }
      ],
      // staffs: [],
      currentSchedule: {},
      timezoneStart: 0,
      timezoneEnd: 0,
      selectedDepartment: [],
      optionDepartment: [],
    };
  },
  methods: {
    async getDataOptionDepartment() {
      const sendApiProject = await this.$http.get(
        apiEndpoints.list_department()
      );
      const { status, data } = sendApiProject;

      if (status && data.result) {
        let options = [
          {
            selectAll: "すべて",
            attributes:
              data.result ?? []
          }
        ];
        this.optionDepartment = options;
      }
    },
    findTimezoneStart() {
      // overwrite the mixin method, fix the value, no need to get the system code
      return {
        system_code_value: 0,
      }
    },
    findTimezoneEnd() {
      // overwrite the mixin method, fix the value, no need to get the system code
      return {
        system_code_value: 24,
      }
    },
    updateUrlFilters () {
      this.getData()
    },
    async getData() {
      this.isLoading = true;
      const sendApiProject = await this.$http.get(
        apiEndpoints.list_schedule_for_staff(1), //ScheduleController.listScheduleStaff
        this.filters
      );
      const { status, data } = sendApiProject;

      if (status && data.result) {
        this.mappingData(data.result);
      }
      this.isLoading = false;
    },
    mappingData(staffs) {
      this.$set(this.staffBySearch, [this.filters.qualification_id, null].join('_'), staffs);
    },
    updateValue: function() {
      let dataSelectedByLocalData = this.allStaffs.filter(item => this.dataSelected.includes(item.id))
      let dataSelectedByCurrentSchedule = this.currentSchedule.assigned_staffs_by_schedule.filter(staff => this.dataSelected.includes(staff.id))

      const mergedData = [...dataSelectedByCurrentSchedule, ...dataSelectedByLocalData]
      const dataSelected = [...new Map(mergedData.map(item => [item['id'], item])).values()];
      this.$emit("dataSelected", {
        dataSelected,
        currentSchedule: this.currentSchedule
      });
      this.closeModal(dataSelected);
    },
    removeSelectedData(id) {
      this.dataSelected = this.dataSelected.filter(item => item !== id);
    },
    openModal(schedule) {
      this.filters.dateValue = this.formatDate(schedule.start_datetime);
      this.filters.assigned_cars = schedule.assigned_cars_by_schedule.map(car => car.id);
      this.dataSelected = schedule.assigned_staffs_by_schedule.map(staff => staff.id);
      this.currentSchedule = schedule;
      this.$nextTick(() => this.$bvModal.show("modal-schedule-staff"));
    },
    formatDate(date, format = 'YYYY-MM-DD') {
      if (!date) return '';

      return moment(date).format(format);
    },
    closeModal() {
      this.$bvModal.hide("modal-schedule-staff");
    },
    qualificationChange() {
      this.getData()
    },
    classHasHour(index, schedule, target = 'f') {
      // schedule という変数名だが実態は user 
      let items = schedule.assigned_staffs_by_schedule; // assigned_staffs_by_schedule は該当日のそのuserの予定一覧
      let current = moment(this.filters.dateValue+ " " +  (index-1  + this.timezoneStart) + ":00:00", "YYYY-MM-DD HH:mm:ss");

      // 他のスケジュールの割り当て　＞　予定登録　＞　Gカレンダーの順にチェックして、
      // 予定が入っているようならその時点でクラスを返して終わり

      for (const item of items) {
        let startDate = moment(item.start_datetime, "YYYY-MM-DD HH:mm:ss");
        let endDate = moment(item.end_datetime, "YYYY-MM-DD HH:mm:ss");

        // チェック中の時間がstartかendと一致している場合「半分塗る」という可能性があるので注意
        //if(current.hour() == startDate.hour()){
        if(current.isSame(startDate, 'hour')){
          //開始時間とチェック時間が一致していて前半チェックの場合、startのminuteが30未満の場合は塗ってよい
          if(target == 'f' && startDate.minute() < 30){
            return 'bg-primary';
          }
          //開始時間とチェック時間が一致していて後半チェックの場合、絶対に塗る
          if(target == 's'){
            return 'bg-primary';
          }
        }

        //if(current.hour() == endDate.hour()){
        if(current.isSame(endDate, 'hour')){
          //終了時間とチェック時間が一致していて前半チェックの場合、00分でなければ塗る
          if(target == 'f' && endDate.minute() != 0){
            return 'bg-primary';
          }
          //終了時間とチェック時間が一致していて後半チェックの場合、30より大きければ塗る
          if(target == 's' && endDate.minute() > 30){
            return 'bg-primary';
          }
        }

        // 開始時間終了時間と一致しない場合は今まで通り
        //if( current.hour() != startDate.hour() && (current.hour() != endDate.hour())){
        if( !current.isSame(startDate, 'hour') && !current.isSame(endDate, 'hour')){
          if (current >= startDate && current < endDate) {
            return 'bg-primary';
          }
        }

      }

      items = schedule.staff_predetermined_schedule;

      for (const item2 of items) {
        let startDate = moment(item2.start_datetime, "YYYY-MM-DD HH:mm:ss");
        let endDate = moment(item2.end_datetime, "YYYY-MM-DD HH:mm:ss");

        // チェック中の時間がstartかendと一致している場合「半分塗る」という可能性があるので注意
        //if(current.hour() == startDate.hour()){
        if(current.isSame(startDate, 'hour')){
          //開始時間とチェック時間が一致していて前半チェックの場合、startのminuteが30未満の場合は塗ってよい
          if(target == 'f' && startDate.minute() < 30){
            return 'bg-primary';
          }
          //開始時間とチェック時間が一致していて後半チェックの場合、絶対に塗る
          if(target == 's'){
            return 'bg-primary';
          }
        }

        //if(current.hour() == endDate.hour()){
        if(current.isSame(endDate, 'hour')){
          //終了時間とチェック時間が一致していて前半チェックの場合、00分でなければ塗る
          if(target == 'f' && endDate.minute() != 0){
            return 'bg-primary';
          }
          //終了時間とチェック時間が一致していて後半チェックの場合、30より大きければ塗る
          if(target == 's' && endDate.minute() > 30){
            return 'bg-primary';
          }
        }

        // 開始時間終了時間と一致しない場合は今まで通り
        //if( current.hour() != startDate.hour() && (current.hour() != endDate.hour())){
        if( !current.isSame(startDate, 'hour') && !current.isSame(endDate, 'hour')){
          if (current >= startDate && current < endDate) {
            return 'bg-primary';
          }
        }

      }

      items = schedule.google_schedule;

      for (const item3 of items) {
        // 「終日」かどうか
        if(item3.is_all_day){
            return 'bg-primary';
        }else{
          let startDate = moment(item3.start_datetime, "YYYY-MM-DD HH:mm:ss");
          let endDate = moment(item3.end_datetime, "YYYY-MM-DD HH:mm:ss");
          // チェック中の時間がstartかendと一致している場合「半分塗る」という可能性があるので注意
          //if(current.hour() == startDate.hour()){
          if(current.isSame(startDate, 'hour')){
            //開始時間とチェック時間が一致していて前半チェックの場合、startのminuteが30未満の場合は塗ってよい
            if(target == 'f' && startDate.minute() < 30){
              return 'bg-primary';
            }
            //開始時間とチェック時間が一致していて後半チェックの場合、絶対に塗る
            if(target == 's'){
              return 'bg-primary';
            }
          }

          //if(current.hour() == endDate.hour()){
          if(current.isSame(endDate, 'hour')){
            //終了時間とチェック時間が一致していて前半チェックの場合、00分でなければ塗る
            if(target == 'f' && endDate.minute() != 0){
              return 'bg-primary';
            }
            //終了時間とチェック時間が一致していて後半チェックの場合、30より大きければ塗る
            if(target == 's' && endDate.minute() > 30){
              return 'bg-primary';
            }
          }

          // 開始時間終了時間と一致しない場合は今まで通り
          //if( current.hour() != startDate.hour() && (current.hour() != endDate.hour())){
          if( !current.isSame(startDate, 'hour') && !current.isSame(endDate, 'hour')){
            if (current >= startDate && current < endDate) {
              return 'bg-primary';
            }
          }
        }

      }
      return '';
    },
    getValueCheckbox(item) {
      const value = [];
      if (item.id) value.push(item.id);

      return value;
    },
    onClickRow(staff) {
      const isSelectedStaff = this.dataSelected.includes(staff.id)
      if (isSelectedStaff) {
        this.removeSelectedData(staff.id)
      } else {
        this.dataSelected.push(staff.id)
      }
    },
    generateHeaderTimes() {
      const timezoneStart = parseInt(this.findTimezoneStart().system_code_value);
      let timezoneEnd = parseInt(this.findTimezoneEnd().system_code_value ?? 23);
      timezoneEnd == 24 && timezoneEnd--;

      this.timezoneStart = timezoneStart
      this.timezoneEnd = timezoneEnd
      this.countHourHeader = timezoneEnd - timezoneStart + 1
      for (let i = timezoneStart; i <= timezoneEnd; i++) {
        this.headers.push({
          text: `${i}時`,
          value: "",
          sortable: false
        })
      }
    },
    onChangeDepartment() {
      let ids = this.selectedDepartment?.map(item => item.id) ?? []
      this.filters.department_id = ids;

      this.getData();
    },
    checkDepartmentChecked(option) {
      return this.selectedDepartment.some(item => item.id == option.id);
    },
    checkDepartmentCheckedAll() {
      return (
        this.selectedDepartment.length ==
        this.optionDepartment[0].attributes.length
      );
    }
  },
  computed: {
    ...mapGetters("options", ["options_tables"]),
    zzQualifications() {
      return [{'qualification': '資格：全て', 'id': null}].concat(this.$store.getters['options/options_tables'].zz_qualifications ?? []);
    },
    staffs() {
      return this.staffBySearch[ [this.filters.qualification_id, null].join('_')] != undefined
        ? this.staffBySearch[[this.filters.qualification_id, null].join('_')]
        : []
    },
    allStaffs() {
      let staffs = [];
      Object.keys(this.staffBySearch).forEach(key => {
        if (Object.keys(this.staffBySearch[key]).length != 0) {
          staffs = [
            ...staffs,
            ...this.staffBySearch[key]
          ]
        }
      })

      return staffs;
    }
  },
  mounted() {
    this.getDataOptionDepartment()
  },
  watch: {
    system_codes: {
      handler(val) {
        if (val.length) {
          this.generateHeaderTimes()
        }
      },
      immediate: true,
    }
  },
};
</script>
<template>
  <div class="mb-2 d-xl-flex">
    <slot name="openBtn">

    </slot>
    <!-- modal area -->
    <b-modal
      size="xl"
      id="modal-schedule-staff"
      centered
      title-class="font-18"
      hide-footer
      scrollable
      @show="getData"
    >
      <template #modal-header="{ close }">
        <div class="d-flex justify-content-between align-items-baseline w-100">
          <h5>作業者予定一覧</h5>
          <b-button
            size="lg"
            variant="primary"
            @click="closeModal"
          >
            戻る
          </b-button>
        </div>
      </template>
      <b-row class="mt-2">
        <b-overlay
          :show="isLoading"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <div>
            <b-row class="my-4">
              <b-col align-self="center" cols="1">作業予定日</b-col>
              <b-col align-self="center">
                  <b-form-input
                    id="example-input"
                    v-model="filters.dateValue"
                    type="text"
                    placeholder="YYYY-MM-DD"
                    autocomplete="off"
                    disabled
                  ></b-form-input>
              </b-col>
              <b-col align-self="center" cols="1">部署</b-col>
              <b-col align-self="center" class="multiple-select-custom">
                <Multiselect
                    :options="optionDepartment"
                    :multiple="true"
                    v-model="selectedDepartment"
                    @input="onChangeDepartment"
                    placeholder=""
                    :close-on-select="false"
                    group-values="attributes"
                    group-label="selectAll"
                    label="name"
                    track-by="id"
                    :group-select="true"
                    selectLabel=""
                    selectGroupLabel=""
                    deselectLabel=""
                    deselectGroupLabel=""
                    selectedLabel=""
                  >
                  <template #option="props">
                    <div class="option__desc d-flex align-items-center gap-2" v-if="props.option['$groupLabel']">
                      <input type="checkbox" @click.self.prevent="checkDepartmentCheckedAll()" :id="`department_all`" :checked="checkDepartmentCheckedAll()">
                      <span class="option__small">{{ props.option.$groupLabel }}</span>
                    </div>
                    <div class="option__desc d-flex align-items-center gap-2" v-else>
                      <input type="checkbox" :id="`department_${props.option.id}}`" :checked="checkDepartmentChecked(props.option)">
                      <span class="option__small">{{ props.option.name }}</span>
                    </div>
                  </template>
                  <template #selection="{ values, search, isOpen }">
                    <span class=""
                          v-if="values.length == 0 || selectedDepartment.length == optionDepartment[0].attributes.length"
                          >所属：全て</span>
                    <span class="multiselect__single"
                      v-if="values.length && values.length != optionDepartment[0].attributes.length"
                      >{{ selectedDepartment.map(item => item.name).join('、') }}</span>
                  </template>
                </Multiselect>
              </b-col>
            </b-row>
            <b-row class="my-4">
              <b-col align-self="center" cols="1">資格</b-col>
              <b-col align-self="center" cols="5">
                <b-form-select
                  class="form-select me-3"
                  v-model="filters.qualification_id"
                  text-field="qualification"
                  value-field="id"
                  :options="zzQualifications"
                  size="lg"
                  @change="qualificationChange"
                />
              </b-col>
            </b-row>
            <CommonTableComponent :height-class="`table-wrapper-500`">
              <thead class="table-light">
                <tr>
                  <th
                    v-for="(item, index) in headers"
                    :key="index"
                    :class="getHeaderClass(item)"
                    style="padding:0;min-width:35px;text-align: center;"
                  >
                    <span v-if="item.sortable" @click="clickSort(item.value)">
                      {{ item.text }}
                      <i :class="getSortClass(item.value)"></i>
                    </span>
                    <span v-else>
                      {{ item.text }}
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in staffs" class="cursor-pointer" @click="onClickRow(item)">
                  <td class="sticky-column-1">
                    <b-form-checkbox
                      :value="item.id"
                      v-model="dataSelected"
                    />
                  </td>
                  <td class="sticky-column-2">
                    <span v-if="item != undefined">{{ item.user_name }}</span>
                  </td>
                  <td class="sticky-column-3">
                    <span  v-if="item.department != undefined">{{ item.department.name }}</span>
                  </td>
                  <td class="cell-custom" v-for="indexAssign in countHourHeader" :key="indexAssign" :class="classHasHour(indexAssign, item) == '' ? 'border-hour' : ''">
                    <div style="display: flex;width: 100%;">
                      <div :id="indexAssign" :class="classHasHour(indexAssign, item, 'f')" class="min-w-100"></div>
                      <div :id="indexAssign" :class="classHasHour(indexAssign, item, 's')" class="min-w-100"></div>
                    </div>
                  </td>
                </tr>
                <tr v-if="!staffs.length">
                  <td colspan="27" class="text-center">
                    データなし。
                  </td>
                </tr>
              </tbody>
            </CommonTableComponent>
          </div>
          <div class="d-flex justify-content-end mt-3">
            <b-button
              size="lg"
              variant="primary"
              @click="updateValue"
            >
              確定
            </b-button>
          </div>
        </b-overlay>
      </b-row>
    </b-modal>
  </div>
</template>

<style lang="scss" scoped>
table tr .cell-custom {
  padding: 0;
  border: 0;
  width: 50px;
  div {
    min-height: 20px;
  }

}

.min-w-100{
  display: inline-block;
  width: 100%;
}

.border-hour {
  border: 1px solid #ced4da!important;
}
</style>
